import React from 'react';
import useStorage from 'src/utils/useStorage';
import Context from './Context';

import { contar as contarNotificacoes } from "src/servicos/notificacao";
import { contarEvolucoesNaoPreenchidas } from "src/servicos/clienteEvolucao";

const StoreProvider = ({ children }) => {
  const [token, setToken] = useStorage('token');
  const [user, setUser] = useStorage('user');
  const [showLinearProgress, setShowLinearProgress] = useStorage('showLinearProgress');
  const [cacheApp, setCacheApp] = useStorage('cacheApp');
  const [qtdeNotificacoesNaoLidas, setQtdeNotificacoesNaoLidas] = React.useState(0);
  const [qtdeEvolucoesPendentes, setQtdeEvolucoesPendentes] = React.useState(0);

  const contarNotificacoesNaoLidas = () => {
    if (token) {
      contarNotificacoes({},{
        onSuccess: response => {
          setQtdeNotificacoesNaoLidas(response.data.qtde);
        }
      });
    }
  }

  const contarEvolucoesPendentes = () => {
    if (token) {
      contarEvolucoesNaoPreenchidas({},{
        onSuccess: response => {
          setQtdeEvolucoesPendentes(response.data.qtde);
        }
      });
    }
  }

  return (
    <Context.Provider
      value={{
        token, setToken,
        user, setUser,
        showLinearProgress, setShowLinearProgress,
        cacheApp, setCacheApp,
        contarNotificacoesNaoLidas, qtdeNotificacoesNaoLidas,
        contarEvolucoesPendentes, qtdeEvolucoesPendentes
      }}
    >
      {children}
    </Context.Provider>
  )
}


export default StoreProvider;
